import type { ComponentProps } from 'react';
import { FieldInfo, useFieldContext } from './shared';
import { MultiCombobox } from '../../custom/multi-combobox';

export default function MultiComboboxNumberField(
	props: ComponentProps<'select'> & {
		label: string;
		search: string;
		empty: string;
		options: { value: number; label: string }[];
		creatable?: boolean;
	},
) {
	const field = useFieldContext<number[]>();

	return (
		<div className={props.className}>
			<div className="text-muted-foreground relative">
				<MultiCombobox
					placeholder={props.label}
					commandEmpty={props.empty}
					searchPlaceholder={props.search}
					creatable={props.creatable}
					options={props.options.map((option) => ({
						value: option.value.toString(),
						label: option.label,
					}))}
					value={field.state.value.map((value) => value.toString())}
					onChange={(value) => field.handleChange(value.map(Number))}
				/>
			</div>
			<FieldInfo fieldState={field.state} />
		</div>
	);
}
